import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';
import { inject } from '@angular/core';
import {
  HttpErrorService,
  isSkippedByHttpErrorInterceptorContext,
} from '@web/common';
import { ToastService } from '@web/shared/ui';

export const HttpErrorInterceptor: HttpInterceptorFn = (request, next) => {
  const httpError = inject(HttpErrorService);
  const toast = inject(ToastService);

  if (isSkippedByHttpErrorInterceptorContext(request)) {
    return next(request);
  }

  return next(request).pipe(
    catchError((error) => {
      if (error instanceof HttpErrorResponse) {
        const content = httpError.extract(error).multiLineMessages();

        toast.show((builder) => builder.initError(content).immortal().build());
      }

      return throwError(() => error);
    }),
  );
};
